export default __webpack_public_path__ + "static/media/bhxh-app-1.c1b48415.jpg";